module.exports = __webpack_public_path__ + "static/media/BigCaslon.9fec2e54.woff";